import { MappedResult } from '../mapped/index.mjs';
import { KeyOf } from './keyof.mjs';
// prettier-ignore
function FromProperties(K, options) {
    return globalThis.Object.getOwnPropertyNames(K).reduce((Acc, K2) => {
        return { ...Acc, [K2]: KeyOf(K[K2], options) };
    }, {});
}
// prettier-ignore
function FromMappedResult(R, options) {
    return FromProperties(R.properties, options);
}
// prettier-ignore
export function KeyOfFromMappedResult(R, options) {
    const P = FromMappedResult(R, options);
    return MappedResult(P);
}
